import * as Action from "@actions/index";

const InitialState = {
  status: "waiting",
  list: null,
  error: null,
};

export default (state = InitialState, action: any): any => {
  switch (action.type) {
    case Action.Networking.Stand.SET_LIST:
      return { ...state, list: action.data };
    case Action.Networking.Stand.SET_STATUS:
      return { ...state, status: action.data };
    case Action.Networking.Stand.SET_ERROR:
      return { ...state, error: action.data };
    case Action.Networking.Stand.CLEAR:
      return { ...state, list: null };
    default:
      return state;
  }
}
